// extracted by mini-css-extract-plugin
export var active = "BabyMenu-module--active--b2864";
export var agences = "BabyMenu-module--agences--41b44";
export var babymenu = "BabyMenu-module--babymenu--42681";
export var burger = "BabyMenu-module--burger--c4f50";
export var buttons = "BabyMenu-module--buttons--756ae";
export var buttonsContainer = "BabyMenu-module--buttonsContainer--448b3";
export var capitalize = "BabyMenu-module--capitalize--14a73";
export var fs14 = "BabyMenu-module--fs-14--bf131";
export var fs16 = "BabyMenu-module--fs-16--c1117";
export var fs20 = "BabyMenu-module--fs-20--e83fa";
export var fs24 = "BabyMenu-module--fs-24--77deb";
export var fs32 = "BabyMenu-module--fs-32--aad0e";
export var fs40 = "BabyMenu-module--fs-40--c05fd";
export var fsItalic = "BabyMenu-module--fs-italic--e08eb";
export var fsLg = "BabyMenu-module--fs-lg--6927e";
export var fsMd = "BabyMenu-module--fs-md--b7e43";
export var fsNormal = "BabyMenu-module--fs-normal--cb5c8";
export var fsSm = "BabyMenu-module--fs-sm--b38d3";
export var fsXl = "BabyMenu-module--fs-xl--9d6fb";
export var fsXs = "BabyMenu-module--fs-xs--77526";
export var fsXxl = "BabyMenu-module--fs-xxl--4539f";
export var fsXxs = "BabyMenu-module--fs-xxs--c4e20";
export var fwBold = "BabyMenu-module--fw-bold--2504e";
export var fwMedium = "BabyMenu-module--fw-medium--4f435";
export var fwNormal = "BabyMenu-module--fw-normal--ec784";
export var gotham_bold = "BabyMenu-module--gotham_bold--0ec0d";
export var gotham_bold_italic = "BabyMenu-module--gotham_bold_italic--b6cc5";
export var gotham_book = "BabyMenu-module--gotham_book--7d5c9";
export var gotham_book_italic = "BabyMenu-module--gotham_book_italic--9c523";
export var lastColItem = "BabyMenu-module--lastColItem--9a4d0";
export var logoLink = "BabyMenu-module--logoLink--bd234";
export var lowercase = "BabyMenu-module--lowercase--69343";
export var menu = "BabyMenu-module--menu--bac7d";
export var search = "BabyMenu-module--search--622f8";
export var searchMobile = "BabyMenu-module--searchMobile--8229e";
export var toggleSwitchButton = "BabyMenu-module--toggleSwitchButton--505a9";
export var toggleSwitchButtonsContainer = "BabyMenu-module--toggleSwitchButtonsContainer--10fdd";
export var uppercase = "BabyMenu-module--uppercase--937bb";